/**
 * User-supplied facts are stored per element but authored in the context of
 * one rule. Filter overrides / audit rows so R303 glazing does not appear on
 * R305 ceiling-height prompts (same room dbId).
 */

import type { UserFactValue } from "../stores/userFactStore";
import type { UserFactRevision } from "./userFactAuditDb";

export function auditRevisionsForRule(
  revisions: UserFactRevision[],
  ruleId: string
): UserFactRevision[] {
  return revisions.filter(r => r.ruleId === ruleId);
}

/** Latest overrides whose audit revision was saved under this rule. */
export function overridesForRule(
  dbId: number,
  ruleId: string,
  allOverrides: Record<number, Record<string, UserFactValue>>,
  revisions: UserFactRevision[]
): Record<string, UserFactValue> {
  const scoped = auditRevisionsForRule(revisions, ruleId);
  const elementOverrides = allOverrides[dbId] ?? {};
  const out: Record<string, UserFactValue> = {};
  for (const rev of scoped) {
    const value = elementOverrides[rev.factKey];
    if (value !== undefined) out[rev.factKey] = value;
  }
  return out;
}

/** Merge model facts with all user overrides on the element (engine evaluation). */
export function allOverridesForElement(
  dbId: number,
  allOverrides: Record<number, Record<string, UserFactValue>>
): Record<string, UserFactValue> {
  return allOverrides[dbId] ?? {};
}
